import * as React from 'react';
import {DashboardAtrasoPorSistema, DashboardAtrasoPorSistemaFields} from "../types/dashboard";
import {axisClasses,  BarPlot, ChartsTooltip, ChartsXAxis, ChartsYAxis, ResponsiveChartContainer} from "@mui/x-charts";
import {useTheme} from "@mui/material";
import CardActions from "../../sistema/components/CardActions";
import {hexToRGBA} from "../../../@core/utils/hex-to-rgba";

interface AtrasoPorSistemaChartProps {
  data: DashboardAtrasoPorSistema[]
}

export default function AtrasoPorSistemaChart({data}: AtrasoPorSistemaChartProps) {
  const theme = useTheme();

  return (
    <CardActions title={'Atraso por Sistema'}
                 colapsable
    >
      <ResponsiveChartContainer
        height={400}
        dataset={data}
        series={[
          {
            type: 'line',
            dataKey: DashboardAtrasoPorSistemaFields.CantMensajes,
            label: '# Mensajes',
            id: 'cantMensajes',
            yAxisId: 'cantMensajes',
          },
          {
            type: 'bar',
            dataKey: DashboardAtrasoPorSistemaFields.AtrasoPromedioDias,
            label: "Atraso Promedio (días)",
            id: 'atrasoPromedioDias',
            yAxisId: 'atrasoPromedioDias',
          },
        ]}
        xAxis={[
          {
            dataKey: DashboardAtrasoPorSistemaFields.Abreviacion,
            valueFormatter: (abreviacion, context) =>
              context.location === 'tick'
                ? abreviacion
                : `Workflow: ${data.find((d) => d[DashboardAtrasoPorSistemaFields.Abreviacion] === abreviacion)?.[DashboardAtrasoPorSistemaFields.Sistema]} (${abreviacion})`,

            scaleType: 'band',
            id: 'x-axis-id',

          },
        ]}
        margin={{left: 70, right: 70}}
        sx={{
          [`.${axisClasses.left} .${axisClasses.label}`]: {
            transform: 'translate(-25px, 0)',
          },
          [`.${axisClasses.right} .${axisClasses.label}`]: {
            transform: 'translate(30px, 0)',
          },
          '.MuiBarElement-root': {
            fill: hexToRGBA(theme.palette.primary.main, 0.08),
            stroke: hexToRGBA(theme.palette.primary.main, 0.75),
            strokeWidth: 1,
            clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 1px), 0 calc(100% - 1px))' // Magia para eliminar el borde inferior
          }
        }}
        yAxis={[{
          id: 'atrasoPromedioDias',

        }]}
      >
        <BarPlot
        />

        <ChartsTooltip/>

        <ChartsYAxis axisId="atrasoPromedioDias" label="Atraso (días)"/>
        <ChartsXAxis label="Sistemas" position="bottom" axisId="x-axis-id"/>

      </ResponsiveChartContainer>
    </CardActions>
  );

}

